import { Button, Paper, Step, StepConnector, StepLabel, Stepper, styled } from '@material-ui/core';
import { connect, useDispatch, useSelector } from 'react-redux';
import { snackbarVariants, styles } from '../../utilities/constants';
import { useEffect, useState } from 'react';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import ProductsRegistration from '../../components/ProductsRegistration/ProductsRegistration';
import RegistrationCheckoutForm from '../../components/Stripe/RegistrationCheckoutForm';
import RetryInvoice from '../../components/Stripe/RetryInvoice';
import StripePaymentElement from '../../components/Stripe';
import { ownerInvoices } from '../Products/api';
import { getLastSubscriptionItems } from '../../api/api-functions';
import { setSubscribe } from '../../actions/authentication-actions';
import useForm from '../../hooks/useForm';
import { useLocation } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import vcLogo from './../../assets/wwa-logo.svg';
import { stepConnectorClasses } from '@mui/material';

const LoginUnsubsciredUser = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const query = new URLSearchParams(location.search);
  const redirectStatus = query.get('redirect_status');
  const user = useSelector((store) => store.user);
  const [failedInvoice, setFailedInvoice] = useState(null);
  const [lastSubProducts, setLastSubProducts] = useState(null);

  const { form, setForm, updateValue } = useForm({
    stepIndex: user?.pendingInvoiceId ? 1 : user?.isReturning ? 1 : 0,
    addedProducts: [],
    addedServices: [],
  });

  useEffect(() => {
    if (redirectStatus) {
      enqueueSnackbar('Registration successful!', snackbarVariants.success);
      goToLogin();
    }
  }, [redirectStatus]);

  const fetchInvoice = async () => {
    const response = await ownerInvoices();
    const { invoicesArray } = response;
    const failedInvoice = invoicesArray.filter(
      (invoice) =>
        invoice?.id === user?.pendingInvoiceId && invoice?.status === 'open'
    );
    if (failedInvoice?.length) setFailedInvoice(failedInvoice[0]);
  };

  const fetchLastSubItems = async () => {
    const data = await getLastSubscriptionItems();
    if (!data?.Items?.length) {
      // All prior products are discontinued or no history found — fall back to product selection.
      updateValue('stepIndex', 0);
      return;
    }

    const products = [];
    const services = [];

    data.Items.forEach((item) => {
      const appType = parseInt(item.ProductAppType, 10);
      const entry = { productId: item.ProductId, priceId: item.PriceId, amount: item.UnitAmount };
      // ProductAppType 1=BasicPackage, 2=AdditionalPackage(Service), 3=ZeroPackage, 5=CertificatePackage
      if (appType === 2) {
        services.push(entry);
      } else {
        products.push(entry);
      }
    });

    setLastSubProducts(data.Items);
    setForm((prev) => ({ ...prev, addedProducts: products, addedServices: services }));
  };

  useEffect(() => {
    if (user?.pendingInvoiceId) fetchInvoice();
    if (user?.isReturning) fetchLastSubItems();
  }, []);

  const handleNext = () => {
    if (form?.stepIndex < 1) updateValue('stepIndex', form?.stepIndex + 1);
  };

  const handlePrev = () => {
    if (form?.stepIndex > 0) updateValue('stepIndex', form?.stepIndex - 1);
  };

  const goToLogin = () => {
    dispatch(setSubscribe(true));
  };

  const onChangeCoupon = (e) => {
    updateValue('paymentCoupon', e.target.value);
  };

  const filterFunc = (array, productId) => {
    const res = array.filter((item) => item.productId === productId);
    return res;
  };

  const onAdd = (productId, priceId, amount, service) => {
    if (service) {
      // Add or remove service
      filterFunc(form?.addedServices, productId).length === 0
        ? setForm({
          ...form,
          addedServices: [
            ...form.addedServices,
            { productId, priceId, amount },
          ],
        })
        : setForm({
          ...form,
          addedServices: form.addedServices.filter(
            (s) => s.productId !== productId
          ),
        });
    } else {
      // New product added
      filterFunc(form.addedProducts, productId).length === 0
        ? setForm({ ...form, addedProducts: [{ productId, priceId, amount }] })
        : setForm({ ...form, addedProducts: [] });
    }
  };

  const isAdded = (productId) => {
    return (
      filterFunc([...form.addedProducts, ...form.addedServices], productId)
        .length !== 0
    );
  };
  const CustomStepIcon = ({ active, completed, icon }) => {
    return (
      <div
        className={`flex items-center justify-center w-[32px] h-[32px] rounded-full border-[1.5px] 
          ${active || completed
            ? 'bg-[#10B981] text-white border-[#10B981]'
            : 'bg-[#F9FAFB] text-black border-[#F9FAFB]'
          }`}
      >
        <span className="text-sm font-semibold">{icon}</span>
      </div>
    );
  };
  // @ts-ignore
  const CustomConnector = styled(StepConnector, {
    name: 'CustomConnector',
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed',
    // @ts-ignore
  })(({ theme, active, completed }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 15,
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderTopWidth: 6,
      borderRadius: 1,
      borderColor: completed || active ? '#10B981' : '#E5E5E5',
      transition: 'border-color 0.3s ease',
    },
  }));




  const renderStepper = (stepIndex) => {
    const steps = ['Products', 'Subscribe'];

    return (
      <div className="w-full flex justify-center mb-6">
        <Stepper
          activeStep={stepIndex}
          alternativeLabel
          className="w-[669px] h-[56px]"
          style={{ background: 'transparent' }}
          connector={<CustomConnector />}
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel StepIconComponent={CustomStepIcon}>
                <span
                  className={`text-sm font-medium 
                    ${stepIndex === index ? 'text-[#006080]' : 'text-[#006080]'}
                  `}
                >
                  {label}
                </span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    );
  };
  const renderButtons = () => (
    <div className="flex flex-row gap-[12px] mt-[24px] justify-center">
      {/* <Button
        fullWidth
        variant="outlined"
        className="max-w-[252px] h-[51px] rounded-[8px] px-[24px] py-[16px] border-[1.5px] text-base font-medium normal-case"
        style={{ color: '#10B981', borderColor: '#10B981', textTransform: 'none', borderRadius: 8 }}
        onClick={form?.stepIndex === 0 ? goToLogin : handlePrev}
        disabled={user?.pendingInvoiceId}

      >
        {form?.stepIndex === 0 ? 'Login' : 'Back'}
      </Button> */}
      <Button
        fullWidth
        variant="contained"
        className="max-w-[252px] h-[51px] rounded-[8px] px-[24px] py-[16px] text-base font-medium normal-case shadow-md"
        style={{ backgroundColor: '#10B981', color: 'white', textTransform: 'none', borderRadius: 8 }}
        disabled={
          form?.stepIndex === 0 && form.addedProducts.length === 0
        }
        onClick={form?.stepIndex === 1 ? goToLogin : handleNext}
      >
        {form?.stepIndex === 1 ? 'Login' : 'Next'}
      </Button>
    </div>
  );

  const getCertQuantity = () => {
    if (!lastSubProducts) return 0;
    const certItem = lastSubProducts.find((i) => parseInt(i.ProductAppType, 10) === 5);
    return certItem ? Number(certItem.Quantity) : 0;
  };

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return <ProductsRegistration onAdd={onAdd} isAdded={isAdded} />;
      case 1:
        return user?.pendingInvoiceId ? (
          <StripePaymentElement>
            <RetryInvoice
              invoice={failedInvoice}
              setIsOpenCheckout={goToLogin}
              pendingInvoice
            />
          </StripePaymentElement>
        ) : (
          <StripePaymentElement>
            <RegistrationCheckoutForm
              productInfo={[...form.addedProducts, ...form.addedServices]}
              paymentCoupon={form?.paymentCoupon}
              onChangeCoupon={onChangeCoupon}
              goToLogin={goToLogin}
              extraCertificates={user?.isReturning ? getCertQuantity() : undefined}
              isReturning={!!user?.isReturning}
            />
          </StripePaymentElement>
        );
      default:
        return '';
    }
  };

  return (
    <div className="flex flex-col w-full items-center">
      <Paper
        className={`flex flex-col w-full text-center md:p-[40px] ${form?.stepIndex === 1 ? 'p-0  max-w-[750px]' : 'p-[20px]'
          } box-border`}
      >
        <img
          className="self-center w-[250px]"
          src={vcLogo}
          alt="VirtualAssistant"
        />
        {isWidthUp('md', props.width) ? renderStepper(form?.stepIndex) : null}
        <>
          {getStepContent(form?.stepIndex)}
          {renderButtons()}
        </>
      </Paper>
    </div>
  );
};

export default withWidth()(connect(null, null)(LoginUnsubsciredUser));
